
import { useState } from "react";
import { HistoryState } from "../types/workout-types";

interface WorkoutHistoryState {
  history: HistoryState[];
  setHistory: React.Dispatch<React.SetStateAction<HistoryState[]>>;
  redoStack: HistoryState[];
  setRedoStack: React.Dispatch<React.SetStateAction<HistoryState[]>>;
  isUndoRedo: boolean;
  setIsUndoRedo: (value: boolean) => void;
  hasEdited: boolean;
  setHasEdited: (value: boolean) => void;
}

export function useWorkoutHistoryState(): WorkoutHistoryState {
  const [history, setHistory] = useState<HistoryState[]>([]);
  const [redoStack, setRedoStack] = useState<HistoryState[]>([]);
  const [isUndoRedo, setIsUndoRedo] = useState(false);
  const [hasEdited, setHasEdited] = useState(false);

  return {
    history,
    setHistory,
    redoStack,
    setRedoStack,
    isUndoRedo,
    setIsUndoRedo,
    hasEdited,
    setHasEdited
  };
}
